<template>
  <div class="error-container">
    <div class="error-illustration">
      <div style="font-size: 100px; color: #667eea;">404</div>
      <p style="color: #666; margin-top: 20px;">页面未找到</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotFound'
}
</script>

<style scoped>
.error-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}
</style>